import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import CouponSpecialStore from 'components/coupon/couponCreation/CouponSpecialStore';
import CouponStoreBehavious from 'components/coupon/couponCreation/CouponStoreBehavious';
import { COUPON_TYPES, LanguageConfig } from 'config/CustomEnums';

import { ContinueWithBackButtons } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import CouponDetailSection from '../../../components/coupon/couponCreation/CouponDetailSection';
import CouponGeneral from '../../../components/coupon/couponCreation/CouponGeneral';
import CouponInstructionSection from '../../../components/coupon/couponCreation/CouponInstructionSection';
import CouponKeyVisual from '../../../components/coupon/couponCreation/CouponKeyVisual';
import { validate } from './CreateCouponValidate';

import './CreateCouponStepOne.scss';

import CouponGeneralBrand from '../../../assets/images/coupon/preview/SingleCoupon_brand.png';
import CouponDefaultPreview from '../../../assets/images/coupon/preview/SingleCoupon_default.png';
import CouponDetailContent from '../../../assets/images/coupon/preview/SingleCoupon_detailContent.png';
import CouponDetailTitle from '../../../assets/images/coupon/preview/SingleCoupon_detailTitle.png';
import CouponKeyVisualImage from '../../../assets/images/coupon/preview/SingleCoupon_image.png';
import CouponInstructionContent from '../../../assets/images/coupon/preview/SingleCoupon_instructionContent.png';
import CouponInstructionTitle from '../../../assets/images/coupon/preview/SingleCoupon_instructionTitle.png';
import CouponGeneralStore from '../../../assets/images/coupon/preview/SingleCoupon_store.png';
import CouponGeneralName from '../../../assets/images/coupon/preview/SingleCoupon_title.png';

const inputWithImageConfig = {
  name: CouponGeneralName,
  relatedBrand: CouponGeneralBrand,
  selectedStores: CouponGeneralStore,
  coverPhoto: CouponKeyVisualImage,
  otherPhotos: CouponKeyVisualImage,
  instructionTitle: CouponInstructionTitle,
  instructionContent: CouponInstructionContent,
  detailsTitle: CouponDetailTitle,
  detailsContent: CouponDetailContent,
};
const defaultImage = CouponDefaultPreview;

const CreateCouponStepTwo = ({
  languages,
  storeLoading,
  storeEditMode,
  couponStores,
}) => {
  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState(null);
  const { getValues, setError, clearErrors } = useFormContext();

  const watchType = getValues()['type'];
  // const parseDataArray = () => {
  //   let formatData = {};
  //   this.dataArray.forEach((item) => {
  //     const language = item.language;
  //     const data = item.data;
  //     const translations = formatData.translations;
  //     const formDataWithLanguage = translations?.[language] || {};
  //     formatData = {
  //       ...formatData,
  //       translations: {
  //         ...translations,
  //         [language]: {
  //           ...formDataWithLanguage,
  //           ...data,
  //         },
  //       },
  //     };
  //   });
  //   return formatData;
  // };

  const getTabs = (language) => {
    return [
      <CouponGeneral language={language} onFocus={setActiveSection} />,
      ...(watchType === COUPON_TYPES.NORMAL
        ? [
            <CouponStoreBehavious
              language={language}
              onFocus={setActiveSection}
            />,
          ]
        : []),
      ...(watchType === COUPON_TYPES.NORMAL
        ? [
            <CouponSpecialStore
              language={language}
              onFocus={setActiveSection}
            />,
          ]
        : []),
      <CouponKeyVisual onFocus={setActiveSection} language={language} />,
      <CouponInstructionSection
        language={language}
        onFocus={setActiveSection}
      />,
      <CouponDetailSection language={language} onFocus={setActiveSection} />,
    ];
  };
  const stepChangeAction = (isBack) => {
    const isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 1,
      isBack,
      extra: { couponStores },
    });

    dispatch({
      type: 'createCoupon/stepChange',
      payload: { isBack: isBack, step: 1, isValid },
    });
  };
  return (
    <div>
      <ContentSections
        languageTabContent={{
          containers: languages?.map((item) => ({
            container: getTabs(item.code),
            key: item.code,
            title: item.sourceName,
          })),
        }}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
        activeSection={activeSection}
      />
      <ContinueWithBackButtons
        disabledContinue={storeLoading}
        continueAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </div>
  );
};

const mapPropsToState = (state) => ({
  languages: state.language.allList,
  storeLoading: state.storeModel.allListLoading,
  storeEditMode: state.storeModel.storeEditMode,
  couponStores: state.storeModel.couponStores,
});

export default connect(mapPropsToState)(CreateCouponStepTwo);